import * as types from "./mutation-types";

export const mutations = {
    [types.SET_GLOBALLOADING](state, globalLoading_payload) {
        state.globalLoading = globalLoading_payload;
    },

    [types.SET_EQUIPMENT_CRAFT](state, equipmentcraft_payload) {
        state.equipmentCraft = equipmentcraft_payload;
    },

    [types.SET_EQUIPMENT_DATA](state, equipmentdata_payload) {
        state.equipmentData = equipmentdata_payload;
    },

    [types.SET_EQUIPMENT_ENHANCE_RATE_DATA](state, equipmentEnhanceRate_payload) {
        state.equipmentEnhanceRate = equipmentEnhanceRate_payload;
    },

    [types.SET_QUEST_DATA](state, questData_payload) {
        state.questData = questData_payload;
    },

    [types.SET_QUEST_REWARD_DATA](state, questRewardData_payload) {
        state.questRewardData = questRewardData_payload;
    },

    [types.SET_WAVE_GROUP_DATA](state, waveGroupData_payload) {
        state.waveGroupData = waveGroupData_payload;
    },

    [types.SET_ENEMY_REWARD_DATA](state, enemyRewardData_payload) {
        state.enemyRewardData = enemyRewardData_payload;
    },

    [types.SET_UNIT_DATA](state, unitData_payload) {
        state.unitData = unitData_payload;
    },

    [types.SET_ACTUAL_UNIT_BACKGROUND](state, actualUnitBackground_payload) {
        state.actualUnitBackground = actualUnitBackground_payload;
    },

    [types.SET_QUEST_AREA_DATA](state, questAreaData_payload) {
        state.questAreaData = questAreaData_payload;
    },

    [types.SET_UNIT_PROFILE](state, unitProfile_payload) {
        state.unitProfile = unitProfile_payload;
    },

    [types.SET_UNIT_PROMOTION](state, unitPromotion_payload) {
        state.unitPromotion = unitPromotion_payload;
    },

    [types.SET_UNIT_SKILL_DATA](state, unitSkillData_payload) {
        state.unitSkillData = unitSkillData_payload;
    },

    [types.SET_UNIT_ATTACK_PATTERN](state, unitAttackPattern_payload) {
        state.unitAttackPattern = unitAttackPattern_payload;
    },

    [types.SET_SKILL_DATA](state, skillData_payload) {
        state.skillData = skillData_payload;
    },

    [types.SET_EXPERIENCE_UNIT](state, experienceUnit_payload) {
        state.experienceUnit = experienceUnit_payload;
    },

    [types.SET_EXPERIENCE_TEAM](state, experienceTeam_payload) {
        state.experienceTeam = experienceTeam_payload;
    },

    [types.SET_GRAND_ARENA_DAILY_RANK_REWARD](state, grandArenaDailyRankReward_payload) {
        state.grandArenaDailyRankReward = grandArenaDailyRankReward_payload;
    },

    [types.SET_GRAND_ARENA_DEFENCE_REWARD](state, grandArenaDefenceReward_payload) {
        state.grandArenaDefenceReward = grandArenaDefenceReward_payload;
    },

    [types.SET_GRAND_ARENA_MAX_RANK_REWARD](state, grandArenaMaxRankReward_payload) {
        state.grandArenaMaxRankReward = grandArenaMaxRankReward_payload;
    },

    [types.SET_GRAND_ARENA_TIME_RANK_REWARD](state, grandArenaTimeRankReward_payload) {
        state.grandArenaTimeRankReward = grandArenaTimeRankReward_payload;
    },

    [types.SET_ARENA_DAILY_RANK_REWARD](state, arenaDailyRankReward_payload) {
        state.arenaDailyRankReward = arenaDailyRankReward_payload;
    },

    [types.SET_ARENA_DEFENCE_REWARD](state, arenaDefenceReward_payload) {
        state.arenaDefenceReward = arenaDefenceReward_payload;
    },

    [types.SET_ARENA_MAX_RANK_REWARD](state, arenaMaxRankReward_payload) {
        state.arenaMaxRankReward = arenaMaxRankReward_payload;
    },

    [types.SET_ARENA_TIME_RANK_REWARD](state, arenaTimeRankReward_payload) {
        state.arenaTimeRankReward = arenaTimeRankReward_payload;
    },

    [types.SET_CHARA_IDENTITY](state, charaIdentity_payload) {
        state.charaIdentity = charaIdentity_payload;
    },

    [types.SET_SKILL_COST](state, skillCost_payload) {
        state.skillCost = skillCost_payload;
    },

    [types.SET_ENEMY_PARAMETER](state, enemyParameter_payload) {
        state.enemyParameter = enemyParameter_payload;
    },

    [types.SET_SKILL_ACTION](state, skillAction_payload) {
        state.skillAction = skillAction_payload;
    },

    [types.SET_UNIT_UNIQUE_EQUIP](state, unitUniqueEquip_payload) {
        state.unitUniqueEquip = unitUniqueEquip_payload;
    },

    [types.SET_UNIQUE_EQUIPMENT_DATA](state, uniqueEquipmentData_payload) {
        state.uniqueEquipmentData = uniqueEquipmentData_payload;
    },

    [types.SET_UNIQUE_EQUIPMENT_ENHANCE_DATA](state, uniqueEquipmentEnhanceData_payload) {
        state.uniqueEquipmentEnhanceData = uniqueEquipmentEnhanceData_payload;
    },

    [types.SET_UNIQUE_EQUIPMENT_ENHANCE_RATE](state, uniqueEquipmentEnhanceRate_payload) {
        state.uniqueEquipmentEnhanceRate = uniqueEquipmentEnhanceRate_payload;
    },

    [types.SET_UNIT_PROMOTION_STATUS](state, unitPromotionStatus_payload) {
        state.unitPromotionStatus = unitPromotionStatus_payload;
    },

    [types.SET_UNIT_RARITY](state, unitRarity_payload) {
        state.unitRarity = unitRarity_payload;
    },

    [types.SET_CHARA_STORY_STATUS](state, charaStoryStatus_payload) {
        state.charaStoryStatus = charaStoryStatus_payload;
    },

    [types.SET_USER_STATUS](state, userStatus_payload) {
        state.userStatus = userStatus_payload;
    },

    [types.SET_EX_EQUIPMENT_CATEGORY](state, exEquipmentCategory_payload) {
        state.exEquipmentCategory = exEquipmentCategory_payload;
    },

    [types.SET_EX_EQUIPMENT_DATA](state, exEquipmentData_payload) {
        state.exEquipmentData = exEquipmentData_payload;
    },

    [types.SET_EX_EQUIPMENTENHANCE_DATA](state, exEquipmentEnhanceData_payload) {
        state.exEquipmentEnhanceData = exEquipmentEnhanceData_payload;
    },

    [types.SET_TALENT_QUEST_DATA](state, talentQuestData_payload) {
        state.talentQuestData = talentQuestData_payload;
    },

    [types.SET_TALENT_QUEST_AREA_DATA](state, talentQuestAreaData_payload) {
        state.talentQuestAreaData = talentQuestAreaData_payload;
    },

    [types.SET_UNIT_TALENT](state, unitTalent_payload) {
        state.unitTalent = unitTalent_payload;
    },
};
